/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'
import { Provider } from 'react-redux'
import {store} from '../../redux/store'
import { PermissionProvider } from '../../context/PermissionContext'


/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { auth } = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
       
      
      <Routes>
        <Route element={<Provider store={store}><App /></Provider>}>
          <Route path='error/*' element={<ErrorsPage />} />
      
          <Route path='logout' element={<Logout />} />
          {auth && auth.token && auth.token ? (
            <>
            
              <Route path='/*' element={ <PrivateRoutes />} />
              <Route index element={<Navigate to='/accessory' />} />
       
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
           {/* <Route path='/*' element={<PrivateRoutes />} /> */}
        </Route>
     
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
